
import React, { useEffect, useState, useRef } from 'react';
 import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import PaginationTable from '../../pagination/Pagination4'; 

const Authentication_Date = async (parms) => {
    
  const response = await fetch(`${process.env.REACT_APP_URL_HEADER}/uidai/UID_Auth_Interface`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(parms),
  });
  if (!response.ok) {
    throw new Error('Failed to fetch distribution data');
  }
  return response.json();
};


const Uidai_Authentication = ({ auth_person, trans_date }) => {

  const [reportData, setReportData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [tabHeading, setTabHeading] = useState(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const monthcardstab = useRef(null); 
 
  useEffect(() => {
    const getData = async () => {
      try {
        const response_data = await Authentication_Date({ auth_person, trans_date});
        setTabHeading(response_data.heading);

        if (response_data.data && response_data.data.length > 0) {
          setReportData(response_data.data);

        } else {
          setReportData([]);
        }
      } catch (errorr) {
        setError(error);
      } finally {
        setLoading(false);
      }
    };

    getData();
  }, [auth_person, trans_date]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (value) => {
    setRowsPerPage(value === 'all' ? reportData.length : parseInt(value, 10));
    setPage(0); 
  };


  useEffect(() => {
    if (!loading && !error && reportData.length > 0 && monthcardstab.current) {
      monthcardstab.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }, [loading, error, reportData]);

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <Box sx={{ display: 'flex' }}>
          <CircularProgress />
        </Box>
      </div>
    );
  }
  if (error) {
    return <div className="mainhead" align="center">Internal Error</div>;
  }
  
 if (reportData.length === 0) {
    return <div className="mainhead" align="center" >{/* No data found */}  {tabHeading}</div>;
  }

  // Pagination logic  
  
  const paginatedData = rowsPerPage === 'all' 
    ? reportData 
    : reportData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  return (
    
    <>
    <br></br><br></br>
      <table ref={monthcardstab} align="center" width="65%" border={1}>
        <thead>
        <tr className="tableheader">
                        <th colSpan={14}>{tabHeading}</th>
                    </tr>
    
<tr class="tableheader">
				<th rowspan="1"><div align="center">Slno</div></th>
				<th rowspan="1"><div align="center">Fps</div></th>
        <th rowSpan="1"><div align="center">Owner Name</div></th>

				<th rowSpan="1"><div align="center">Total<br/>Authentication</div></th>
				<th rowSpan="1"><div align="center">Min Time<br/>(Mill. Sec)</div></th>
				<th rowSpan="1"><div align="center">Max Time<br/>(Mill. Sec)</div></th>
			</tr>
			
        </thead>
        <tbody>
          {paginatedData.map((item, index) => (
            <tr key={item.fps_id}>
              <td style={{ textAlign: 'left' }}>{rowsPerPage === 'all' ? index + 1 : index + 1 + page * rowsPerPage}</td> {/* Adjusted Sl.No */   }
              <td style={{ textAlign: 'left' }}>{item.fps_id}</td>
          
              <td style={{ textAlign: 'left' }}>{item.ownername}</td>

              <td style={{ textAlign: 'right' }}>{item.total}</td>

              <td style={{ textAlign: 'right' }}>{item.min}</td>

              <td style={{ textAlign: 'right' }}>{item.max}</td>
      
            </tr>
          ))}
        </tbody>
      </table>
      <br /><br />
      <div width="75%" style={{display:'flex', justifyContent:'right',alignItems:'start' , width:'95%'}}> 
      <PaginationTable
        count={reportData.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      /></div>
<br />
<br />

      <div> {page}</div>
      
    </>
  );   
};

export default Uidai_Authentication;


